import React from 'react';
import styles from './Header.module.scss';
import Box from '@/components/UI/box/Box';
import Logo from '@/components/layout/header/logo/Logo';
import useHeader from '@/components/layout/header/_hooks/useHeader';
import dynamic from 'next/dynamic';
import Icon from '@/components/UI/icon/Icon';
import useRouterBack from '@/hooks/useRouterBack';
import { useIsWhiteLabel } from '@/components/app/providers/whiteLabelProvider/WhiteLabelProvider';
import { useRouter } from 'next/router';
interface HeaderProps {
  defaultLightMode?: boolean;
  id?: number;
  params?: any;
  mapIsOpen?: boolean;
  rightId?: boolean;
  hasBackBtn?: boolean;
}
const SearchBar = dynamic(() => import('@/components/layout/header/searchBar/SearchBar'), {
  ssr: false
});
const Navbar = dynamic(() => import('@/components/layout/header/navbar/Navbar'), {
  ssr: false
});
const Header: React.FC<HeaderProps> = ({
  defaultLightMode = true,
  id,
  params,
  mapIsOpen = false,
  rightId = true,
  hasBackBtn
}) => {
  const {
    showHeader,
    isLightMode,
    firstTimeTransition,
    defaultSearchTxt,
    positionValue,
    isMobile
  } = useHeader({
    params,
    mapIsOpen,
    defaultLightMode
  });
  const {
    handleBack
  } = useRouterBack();
  const isWhiteLabel = useIsWhiteLabel();
  const router = useRouter();
  return <Box component={'header'} className={`
      ${styles['container']}
      ${styles['position-' + positionValue]}
      ${mapIsOpen && isMobile ? styles['hidden'] : ''}
      ${isLightMode ? styles['light-mode'] : ''}
      ${showHeader ? styles['show-mobile-header'] : ''}
      ${firstTimeTransition.current ? styles['has-transition'] : ''}
      `} data-sentry-element="Box" data-sentry-component="Header" data-sentry-source-file="Header.tsx">
      <Box className={styles['wrapper']} data-sentry-element="Box" data-sentry-source-file="Header.tsx">
        <Box className={styles['arrow-back-container']} data-sentry-element="Box" data-sentry-source-file="Header.tsx">
          {(hasBackBtn || isWhiteLabel && router.pathname !== '/') && <Icon name="arrow-right-1" type="highEmphasis" size="large" onClick={handleBack} />}
          {!isWhiteLabel && <Logo isLightMode={isLightMode} />}
        </Box>
        <SearchBar isLightMode={isLightMode} defaultSearchTxt={defaultSearchTxt} data-sentry-element="SearchBar" data-sentry-source-file="Header.tsx" />
        <Navbar isLightMode={isLightMode} id={!rightId && id ? id : null} data-sentry-element="Navbar" data-sentry-source-file="Header.tsx" />
      </Box>
    </Box>;
};
export default Header;